
import React, { useState, useEffect } from 'react';
import '../../styles/TabSwitcher.scss';
import axios from 'axios';

import '../../styles/antd-message.scss';

function OnChainTab() {
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = React.useState(0);
    const [totalCount, setTotalCount] = React.useState(0);
    const [totalPage, setTotalPage] = React.useState(0);
    const [limit, setLimit] = React.useState(10);
    const [requestHistory, setRequestHistory] = React.useState([]);
    const [randomCount, setRandomCount] = React.useState(0);
    const [totalRequest, setTotalRequest] = React.useState(0);


    useEffect(() => {
      setIsLoading(true);
      handleInitData();

      const timer = setInterval(() => {
        // 注:在setCount中使用箭头函数是最好方式之一,只有一个timer生成
          listenData();
      }, 2000)
      return () => {
        clearInterval(timer)
      }
    },[]);


        
    const listenData = async () => {
      
      const data = {
      };
      
      try {
          const result = await axios(
              {
                  method: "post",
                  url: '/faucet-api/random/GetCount',
                  // baseURL: "http://127.0.0.1:3001",
                  headers: {
                  'Content-Type': 'application/json',
                  },
                  data
              });
        
          console.log(result.data.res.total)
          setRandomCount(result.data.res.total)
        } catch {
        console.log('api request failed.');

        }

      const data_request = {
      };

      try {
            const result_request = await axios(
              {
                  method: "post",
                  url: '/faucet-api/history/GetTotalOnChainReqNum',
                  // baseURL: "http://127.0.0.1:3001",
                  headers: {
                  'Content-Type': 'application/json',
                  },
                  data: data_request
              });
            setTotalRequest(result_request.data.res.total)
        } catch {
          console.log('get all_request number api request failed.');
        }
  };


    
    const handleInitData = async () => {
        const data = {
            limit: limit,
            offset: page
        };
        try {

        const result = await axios(
            {
                method: "post",
                url: '/faucet-api/history/ListOnChainHistory',
                // baseURL: "http://127.0.0.1:3001",
                headers: {
                'Content-Type': 'application/json',
                },
                data
            });
        let total = result.data.res.total;
        setTotalCount(total);
        let total_page = Math.ceil(total/10) - 1
        setTotalPage(total_page)

        setRequestHistory(result.data.res.data)

      const data_random = {
      };

      
      const result_random = await axios(
          {
              method: "post",
              url: '/faucet-api/random/GetCount',
              // baseURL: "http://127.0.0.1:3001",
              headers: {
              'Content-Type': 'application/json',
              },
              data: data_random
          });
      setRandomCount(result_random.data.res.total)



      const data_request = {
      };

      
      const result_request = await axios(
          {
              method: "post",
              url: '/faucet-api/history/GetTotalOnChainReqNum',
              // baseURL: "http://127.0.0.1:3001",
              headers: {
              'Content-Type': 'application/json',
              },
              data: data_request
          });
      setTotalRequest(result_request.data.res.total)
    } catch {
      console.log("init api error.");
    }
    };
  
    const handlePrevious = async() => {
      try {
        let nowPage = page - 1;
        let nowLimit = 10
        
        console.log("-----11")
        console.log(nowPage, page)
        if (nowPage<=0) {
          nowPage = 0
        }
        console.log(nowPage, page)
        
        const data = {
            offset: nowPage,
            limit: nowLimit
        };
        const result = await axios(
            {
                method: "post",
                url: '/faucet-api/history/ListOnChainHistory',
                // baseURL: "http://127.0.0.1:3001",
                headers: {
                'Content-Type': 'application/json',
                },
                data
            });
          console.log(page, limit)

          console.log(result.data.res.data)
          setRequestHistory(result.data.res.data)

          setPage(nowPage)
          setLimit(nowLimit)

          let total = result.data.res.total;
          setTotalCount(total);
          let total_page = Math.ceil(total/10) - 1
          setTotalPage(total_page)
          } catch {
            console.log("previous error");
          }

    }

    const handleNext = async() => {
      try {
        let nowPage = page + 1;
        let nowLimit = limit
        if (nowPage>=totalPage) {
          nowPage = totalPage
          nowLimit = totalCount % 10
          
        } else {
          nowLimit = 10
        }
        const data = {
            offset: nowPage,
            limit: nowLimit
        };
        console.log(data)
        const result = await axios(
            {
                method: "post",
                url: '/faucet-api/history/ListOnChainHistory',
                // baseURL: "http://127.0.0.1:3001",
                headers: {
                'Content-Type': 'application/json',
                },
                data
            });

          console.log(nowPage, nowLimit)
          console.log(result.data.res.data)
          setRequestHistory(result.data.res.data)
          setPage(nowPage)
          setLimit(nowLimit)
          
          let total = result.data.res.total;
          setTotalCount(total);
          let total_page = Math.ceil(total/10) - 1
          setTotalPage(total_page)

        } catch {
          console.log("next error");
        }
    }
    
    
    // const handleUserAddressesInfo = async () => {
    //   let eth_rpc = "https://sepolia.infura.io/v3/fe4f350da7584eafad57c774a4e29c32"
    //   const provider = new ethers.providers.JsonRpcProvider(eth_rpc)
    //   // USDT的合约地址
    //   const contractAddress = '0x07c7464515FE99aD97FfE32949340DC13B30bdA1'
    //   // 构建USDT的Transfer的ABI

    //   // 生成USDT合约对象
    //   const Abi = [
    //     "event RandomWordsRequested(uint256 requestId, uint32 callbackGasLimit, uint32 numWords, address indexed sender)",
    //     "event RandomWordsFulfilled(uint256 indexed requestId, bool success)"
    // ];
    //   const contract = new ethers.Contract(contractAddress, Abi, provider);

    //   const nowBlock = await provider.getBlockNumber()
    //   console.log(`当前区块高度: ${nowBlock}`);
    //   console.log(`打印事件详情:`);
    //   let requestRandomWordEvents = await contract.queryFilter('RandomWordsRequested') // 返回RandomWords请求。
    //   // let requestRandomWordEvents = await contract.queryFilter('RandomWordsRequested', block - 1010, block) // 返回RandomWords请求。

    //   console.log(requestRandomWordEvents)

    //   let fulfillRandomWordEvents = await contract.queryFilter('RandomWordsFulfilled') // 返回RandomWords请求。
    //   console.log(fulfillRandomWordEvents)

    //   let res_data = requestRandomWordEvents.map((req_event) => {
    //     let qrng_status = "Pending"
    //     let block_num = req_event.blockNumber
    //     let consumer = req_event.args['sender']
    //     let num_words = req_event.args['numWords']
    //     let tx_hash = req_event.transactionHash
    //     let tx_url = `https://sepolia.etherscan.io/tx/${tx_hash}`
        
    //     if ((nowBlock - block_num) > 100) {
    //       qrng_status = "Fail"
    //       tx_url = ""
    //       tx_hash = ""
    //     }
    //     console.log(req_event.args['requestId']['_hex'])
    //     fulfillRandomWordEvents.map((ful_event) => {
    //       if (ful_event.args['requestId']['_hex'] === req_event.args['requestId']['_hex']) {
    //         console.log("request id is same.");
    //         if (ful_event.args['success'] === true) {
    //           qrng_status = "Success"
    //         } else {
    //           qrng_status = "Fail"
    //         }

    //         block_num = ful_event.blockNumber
    //         tx_hash = ful_event.transactionHash
    //         tx_url = `https://sepolia.etherscan.io/tx/${tx_hash}`
    //       }
    //     })
    //     return {
    //       block_num,
    //       consumer,
    //       num_words,
    //       qrng_status,
    //       tx_hash,
    //       tx_url,
    //     }
    //   })
    //   setRequestHistory(res_data);
    //   // // 持续监听USDT合约
    //   // console.log("\n2. 利用contract.on()，持续监听事件");
    //   // contract.on('RandomWordsRequested', (from, to, value)=>{
    //   //   console.log(
    //   //   // 打印结果
    //   //   // `${from} -> ${to} ${ethers.utils.formatUnits(ethers.BigNumber.from(value),6)}`
    //   //   `${from} -> ${to} ${value}`
    //   //   )
    //   // })
    //   // let oldBlock = await web3.eth.getBlockNumber();
    //   // let nowBlock = oldBlock;
    //   // let endBlock = oldBlock
    //   // console.log("==========================", oldBlock)
    //   // let i = 0
    //   // while (fromBlock <= endBlock) {
    //   //   if (i != 0) {
    //   //     if (oldBlock < nowBlock) {
    //   //       fromBlock = endBlock + 1
    //   //       endBlock = nowBlock
    //   //       oldBlock = nowBlock
    //   //     } else {
    //   //       console.log('sleep wait.')
    //   //       await sleep(1000)
    //   //       nowBlock = await web3.eth.getBlockNumber();
    //   //       continue
    //   //     }
    //   //   }
    //   //   console.log(`debug oldBlock: ${oldBlock}, nowBlock: ${nowBlock}, fromBlock: ${fromBlock}, endBlock: ${endBlock}`)
    //   //   await web3.eth
    //   //     .getPastLogs({
    //   //       fromBlock: fromBlock,
    //   //       toBlock: endBlock,
    //   //       topics: [
    //   //         [RequestRandomSign],
    //   //       ],
    //   //       address: contract,
    //   //     })
    //   //     .then(async (logs) => {
    //   //       for (const log of logs) {
    //   //         console.log(log.topics[0] === RequestRandomSign)
    //   //         if (log.topics[0] === RequestRandomSign) {
    //   //           await handleMessage(log);
    //   //         } else {
    //   //           console.log(log.blockNumber, "not found")
    //   //         }
    //   //       }
    //   //       console.log(logs.length)
    //   //     })
    //   //     .catch((err) => {
    //   //       console.error(err.message || err)
    //   //     })

    //   //   await sleep(1000)
    //   //   nowBlock = await web3.eth.getBlockNumber();
    //   //   i += 1;
    //   // }
    //     setIsLoading(true);
    // };
  
    const formatTime = (request_at) => {
      const requestTime = new Date(request_at)
        .toLocaleTimeString('zh', {

          year:  "numeric",
          month: "2-digit",
          day:   "2-digit",
          hourCycle: 'h23',
          hour:   '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }).split('/').join('-');
      return requestTime
    }

    if (isLoading) {
        return (

          <div className="tab-pane">
                          <div className='linked-address-head'>
                          On-chain faucet                
                          </div>
                          <div className="card chain-form-card">
              <tbody className=''>
                <tr className="">
                <th className="chain-name message-detail-font">Available bits</th>
                <th className="chain-name set-width">{randomCount * 256} bits ({randomCount} bytes)</th>
                </tr>
              </tbody>
              
            </div>
            <div className="card chain-form-card">
              <tbody className=''>
                <tr className="">
                <th className="chain-name message-detail-font">Total requests</th>
                <th className="chain-name">{totalRequest} bytes</th>
                </tr>
              </tbody>
              
            </div>
            <div className="card chain-form-card">
              <tbody className=''>
                <tr className="">
                <th className="chain-name message-detail-font">Network</th>
                <th className="chain-name set-width">BNB Smart Chain Mainnet</th>
                </tr>
              </tbody>
              
            </div>
              { requestHistory.length === 0
                ? <></>

                : <>
                  { requestHistory.map((request_history, index) => {
            return (
              <div>
              { 
                index === 0 ?
                <>
                  <div className='incentives-history-tips'>
                  </div>
                  <div className='linked-address-head'>
                    Request history
                  </div>
                  <thead className='card-form-head card-detail-form-head'>
                    <tr className=''>
                      <th className="time-name-form-head">TIME</th>
                      <th className="chain-name-form-head">CONSUMER</th>
                      <th className="chain-name-form-head">QRNG BYTES</th>
                      <th className="chain-name-form-head">STATUS</th>
                      <th className="chain-name-form-head">TXH HASH</th>
                    </tr>
                  </thead>
                </>

                : null
              }
            <div className="card chain-form-card">
              <tbody className=''>
                <tr className="">
                <th className="chain-name time-name">{formatTime(request_history.request_at)}</th>
                <th className="chain-name">{request_history.consumer.substring(0, 5) + '...' + request_history.consumer.substring(request_history.consumer.length-3,)}</th>
                <th className="chain-name">{request_history.number}</th>
                <th className={request_history.status==='Success'? "claimed-status chain-name big-font" : request_history.status==='Fail'? "fail-status chain-name big-font": "expired-status chain-name big-font"}>{request_history.status}</th>
                {
                  request_history.tx_hash === "" ?
                  <th className="chain-name"></th>
                  :
                <th className="chain-name">{request_history.tx_hash.substring(0, 8) + '...' + request_history.tx_hash.substring(request_history.tx_hash.length-5,)}</th>
                }
                </tr>
              </tbody>
              {request_history.tx_url === "" ?
                  <></>              
                :
              <a href={request_history.tx_url} target="_blank"><div className="card-btn detail-btn"><div><img src='/data/staking/chevron-right-sm.png'/></div></div></a>

            }

            </div>
              </div>
              
            )

          })}

          { requestHistory.length === 0 ?
                <></>
              :
              <div className='page-limit-body'>
              <div className='page-previous' onClick={handlePrevious}>
                <img src="/data/staking/chevron-left-sm.png"/>
                Previous
              </div>
              <div className='page-next' onClick={handleNext}>
                Next 
              <img src="/data/staking/chevron-right-sm.png"/>
              </div>
            </div>
          }
                </>
              }
          </div>
        );
  } 
}

export default OnChainTab;
